<template>
  <div>
    <b>Disclaimer:</b> Calculations must be re-checked. The shown results can be
    different from the calculated results because of rounding. <br />©2021 -
    <a href="https://www.facebook.com/KeepMovingPharmacist/">KMP</a>. All rights reserved.
  </div>
</template>

<script>
export default {
  name: "Kmpfooter",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div {
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 60px;
}
ul#ref {
  list-style-type: disc;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
